import { Component, inject, computed, effect } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/services/auth.service';
import { TenantService } from 'src/app/tenant/services/tenant.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    standalone: false
})
export class HomePageComponent {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly tenantService = inject(TenantService);

  private readonly userData = toSignal(this.authService.userData$);
  private readonly isAuthenticated = toSignal(this.authService.isAuthenticated$);

  constructor() {
    // Watch user authentication state and load tenant if needed
    effect(() => {
      const isAuth = this.isAuthenticated();
      const currentTenantCode = this.tenantService.tenantCode();
      
      if (isAuth && !currentTenantCode) {
        this.tenantService.loadUserDefaultTenant().subscribe((tenant) => {
          if (tenant?.shortCode) {
            this.router.navigate([tenant.shortCode, 'admin']);
          }
        });
      }
    });
  }

  readonly buttonText = computed(() => {
    return this.isAuthenticated() ? 'Manage Lockers' : 'Sign In';
  });

  readonly buttonIcon = computed(() => {
    return this.isAuthenticated() ? 'lock' : 'account_circle';
  });

  onButtonClick() {
    if (this.isAuthenticated()) {
      const currentTenantCode = this.tenantService.tenantCode();
      if (currentTenantCode) {
        this.router.navigate([currentTenantCode, 'admin']);
      } else {
        // Load default tenant if not already loaded
        this.tenantService.loadUserDefaultTenant().subscribe((tenant) => {
          if (tenant?.shortCode) {
            this.router.navigate([tenant.shortCode, 'admin']);
          }
        });
      }
    } else {
      this.authService.login();
    }
  }
}
